<template>
  <div class="user-list">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>用户管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="search">
      <div style="margin-right: 20px;">
        <el-input placeholder="请输入手机号" prefix-icon="el-icon-search" size="small" clearable v-model="key"
          @keyup.enter.native="Query"></el-input>
      </div>
      <div style="margin-right: 20px;">
        <el-input placeholder="请输入用户名" prefix-icon="el-icon-search" size="small" clearable v-model="user_name"
          @keyup.enter.native="Query"></el-input>
      </div>
      <div style="margin-right: 20px;">
        <el-input placeholder="请输入用户id" prefix-icon="el-icon-search" size="small" clearable v-model="user_id"
          @keyup.enter.native="Query"></el-input>
      </div>
      <div style="margin-right: 20px;"> <el-button type="primary" size="small" @click.native="Query">查询</el-button>
      </div>
      <div> <el-button type="warning" size="small" @click.native="resetBtn">重置</el-button></div>

      <div style="margin-left: 80px;"><el-button class="el-button--success">男</el-button></div>
      <div style="margin-left: 10px;"><el-button class="el-button--pink">女</el-button></div>
      <div style="margin-left: 10px;"><el-button>性别为空</el-button></div>
    </div>
    <div class="time-screen">
      <el-tag :effect="time_name === item.value ? 'light' : 'plain'" v-for="(item,index) in time_list" :key="index"
        @click="checkTime(item.value)">{{ item.name }}</el-tag>
      <div class="time">
        <el-date-picker v-model="time_slot" size="small" type="daterange" range-separator="至" start-placeholder="开始日期"
          end-placeholder="结束日期" value-format="yyyy-MM-dd">
        </el-date-picker>
      </div>
      <el-button type="primary" size="small" @click.native="Query_1">确认</el-button>
      <el-button type="success" size="small" @click="downloadRecord" :loading="buttonLoading">{{ buttonLoading ?
        '导出中，请稍后' : '导出记录' }}</el-button>
    </div>
    <div class="list">
      <el-table :data="tableData" border style="width: 100%" :row-class-name="tableRowClassName" size="small">
        <el-table-column prop="id" label="用户id" fixed width="70">
          <template slot-scope="scope">
            <a class="user_information" @click="goTo('/user-information', scope.row.id)">
              <el-button
                :class="{ 'el-button--success': scope.row.gender === '男', 'el-button--pink': scope.row.gender === '女' }"
                size="mini">{{ scope.row.id }}</el-button>
            </a>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="用户名" fixed width="75">
        </el-table-column>
        <el-table-column prop="mobile" label="手机号" width="95">
        </el-table-column>
        <el-table-column prop="ctime" label="注册时间" width="133">
        </el-table-column>
        <el-table-column prop="last_login_time" label="最后登录时间" width="133">
        </el-table-column>
        <el-table-column prop="reg_days" label="注册总天数" width="60">
        </el-table-column>
        <el-table-column prop="login_count" label="登录次数" width="50">
        </el-table-column>
        <el-table-column prop="login_days" label="登陆总天数" width="60">
        </el-table-column>
        <el-table-column prop="session_duration" label="登录总时长" width="125">
        </el-table-column>
        <el-table-column prop="daily_avg_duration" label="日均训练时长" width="60" :formatter="formatTime">
        </el-table-column>
        <el-table-column prop="completed_days" label="完成推送天数" width="60">
        </el-table-column>
        <el-table-column prop="completion_rate" label="任务完成率" width="65" :formatter="formatPercentage">
        </el-table-column>
        <el-table-column prop="training_days" label="参与训练天数" width="60">
        </el-table-column>
        <el-table-column prop="participation_rate" label="训练参与率" width="70" :formatter="formatPercentage">
        </el-table-column>
        <el-table-column prop="peak_periods" label="高峰使用时段及占比" width="120" :formatter="formatTimeRange">
        </el-table-column>
        <el-table-column prop="age" label="年龄" width="50" :formatter="formatAge">
        </el-table-column>
        <el-table-column prop="gender" label="性别" width="50">
        </el-table-column>
        <el-table-column prop="height" label="身高(cm)" width="75">
        </el-table-column>
        <el-table-column prop="weight" label="体重(kg)" width="70">
        </el-table-column>
        <!-- <el-table-column prop="culture" label="学历" width="80">
        </el-table-column> -->
        <!-- <el-table-column prop="province" label="用户所在省份" width="80">
        </el-table-column>
        <el-table-column prop="city" label="用户所在市" width="80">
        </el-table-column> -->
        <!-- <el-table-column prop="district" label="用户所在区" width="80">
        </el-table-column> -->
        <el-table-column prop="district" label="更多操作" fixed="right" width="100">
          <template slot-scope="scope">
            <el-dropdown>
              <el-button size="small" type="primary" trigger="click">
                操作<i class="el-icon-edit"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <el-button class="btn_red" type="primary" size="small" @click="clickGrouping(scope.row.id)">
                    用户分组
                  </el-button>
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-button class="btn_orange" type="warning" size="small" @click="goToTaskPage(scope.row.id)">
                    用户任务
                  </el-button>
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-button class="btn_yellow" type="success" size="small" @click="getVipInfo(scope.row.id)">
                    会员信息
                  </el-button>
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-button class="btn_green" type="danger" size="small" @click="getRebate(scope.row.id)">
                    返现详情
                  </el-button>
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-button class="btn_cyan" type="primary" size="small" @click="getOrderDetails(scope.row.id)">订单详情</el-button>
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-button class="btn_blue" type="info" size="small"
                    @click="goTo('/user-info', scope.row.id, scope.row.name)">游戏详情</el-button>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="district" label="用户分组" fixed="right" width="70">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="clickGrouping(scope.row.id)">
              查看
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="district" label="用户任务" width="70" fixed="right">
          <template slot-scope="scope">
            <el-button type="warning" size="mini" @click="goToTaskPage(scope.row.id)">
              查看
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="district" label="vip信息" width="70" fixed="right">
          <template slot-scope="scope">
            <el-button type="success" size="mini" @click="getVipInfo(scope.row.id)">
              详情
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="district" label="返现详情" width="70" fixed="right">
          <template slot-scope="scope">
            <el-button type="danger" size="mini" @click="getRebate(scope.row.id)">
              详情
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="district" label="订单详情" width="70" fixed="right">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="getOrderDetails(scope.row.id)">详情</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="游戏详情" width="70" fixed="right">
          <template slot-scope="scope">
            <el-button type="info" size="mini" @click="goTo('/user-info', scope.row.id, scope.row.name)">详情</el-button>
          </template>
        </el-table-column> -->
      </el-table>
    </div>
    <div class="block">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages"
        :page-sizes="[10, 20, 30, 40]" :page-size="limit" layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog title="会员信息" :visible.sync="centerDialogVisible" width="50%" center>
      <span>
        <div class="dialog_style">
          <div class="flex_box">
            <div>用户ID:</div>
            <div>会员等级:</div>
            <div>会员类型:</div>
            <div>会员开始日期:</div>
            <div>会员结束日期:</div>
            <div>会员时长:</div>
            <div>会员剩余时长:</div>
            <div>会员是否有效:</div>
            <div>会员等级详细说明:</div>
          </div>
          <div class="right_box">
            <div class="el_from_span">{{ userVipInfo.userId || '无' }}</div>
            <div class="el_from_span">{{ userVipInfo.vip_level || '无' }}</div>
            <div class="el_from_span">{{ userVipInfo.type ? userVipInfo.type + '会员' : '无' }}</div>
            <div class="el_from_span">{{ userVipInfo.vip_start_time || '无' }}</div>
            <div class="el_from_span">{{ userVipInfo.vip_end_time || '无' }}</div>
            <div class="el_from_span">{{ userVipInfo.duration_days || '无' }}天</div>
            <div class="el_from_span">{{ userVipInfo.remainingVIPdays || '无' }}天</div>
            <div class="el_from_span">{{ userVipInfo.is_active ? '有效' : '无效' }}</div>
            <div class="el_from_span">{{ userVipInfo.benefits }}</div>
          </div>
        </div>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="centerDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>


<script>
export default {
  name: 'user',
  data() {
    return {
      pages: 1,
      limit: 10,
      key: '',
      time_slot: ['', ''],
      time_name: '',
      start_time: '',
      end_time: '',
      time_list: [
        { name: '今天', value: 'today' },
        { name: '昨天', value: 'yesterday' },
        { name: '近7天', value: 'week' },
        { name: '近30天', value: 'month' }
      ],
      tableData: [],
      total: 0,
      totalPayment: 0, // 总计支付金额
      registrationCount: 0, // 新注册人数
      centerDialogVisible: false,
      userVipInfo: {},
      user_name: '',
      user_id: this.$route.query.user_id || '',
      hasInput: false, // 标记是否有过输入
      exportData: true,
      buttonLoading: false,
    }
  },
  methods: {
    formatTimeRange(row, column, value) {
      if (!value || !Array.isArray(value) || value.length === 0) return '';

      return value.map(item => {
        if (!Array.isArray(item) || item.length < 2) return item;

        // 保留第一个元素（时间段文本），第二个元素添加%
        const periodText = item[0];
        const percentage = item[1];

        // 直接拼接%，不做任何四舍五入
        return `${periodText}-${percentage}%`;
      }).join('、'); // 多个时间段用顿号连接
    },
    formatPercentage(row, column, value) {
      if (value === undefined || value === null) return '-';

      // 直接截取两位小数（不四舍五入）
      const fixedValue = (Math.floor(value * 100) / 100).toFixed(2);
      return `${fixedValue}%`;
    },
    formatAge(row, column, cellValue) {
      return cellValue + '岁';
    },
    formatTime(row, column, cellValue) {
      return cellValue + '分钟';
    },
    formatDay(row, column, cellValue) {
      return cellValue + '天';
    },
    formatDay(row, column, cellValue) {
      return cellValue + '天';
    },
    getUserList() {
      this.$get(`/v1/admin/users?pages=${this.pages}&limit=${this.limit}&key=${this.key}&time_name=${this.time_name}&start_time=${this.start_time}&end_time=${this.end_time}&user_name=${this.user_name}&user_id=${this.user_id}`, {})
        .then((res) => {
          if (res.data.status === 'success') {
            console.log(res.data.data.data, '0000')
            // res.data.data.data.forEach(item => {
            //   // 保留两位小数且不进行四舍五入
            //   item.completion_rate = (Math.floor(item.completion_rate * 100) / 100).toFixed(2) + '%';
            // });
            this.tableData = res.data.data.data;
            this.total = res.data.data.total;
          } else {
            this.$msg(res.data.msg)
          }
        });
    },
    Query() {
      if (this.key) {
        localStorage.setItem('hasUserInput', 'true');
        localStorage.setItem('phoneNumber', this.key);
      }
      console.log('执行了')
      this.pages = 1;
      this.getUserList();
    },
    Query_1() {
      this.pages = 1;
      this.time_name = '';
      this.start_time = this.time_slot[0];
      this.end_time = this.time_slot[1];
      this.getUserList();
    },
    checkTime(time_name) {
      this.start_time = '';
      this.end_time = '';
      this.time_slot = ['', ''];
      this.time_name = time_name;
      this.getUserList();
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return '';
      } else {
        return 'success-row';
      }
    },
    handleSizeChange(val) {
      this.limit = val;
      this.getUserList()
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.pages = val;
      this.getUserList()
      console.log(`当前页: ${val}`);
    },
    goTo(path, user_id, name) {
      this.$router.push({
        path: path,
        query: {
          user_id: user_id,
          name: encodeURI(name)
        }
      })
    },
    getOrderDetails(id) {
      // console.log(id)
      this.$router.push({
        path: '/userOrder',
        query: {
          user_id: id,
        }
      });
    },
    getRebate(id) {
      // console.log(id)
      this.$router.push({
        path: '/userRebate',
        query: {
          user_id: id,
        }
      });
    },
    getVipInfo(id) {
      this.$get(`/v1/vip-info?user_id=${id}`, {})
        .then((res) => {
          // console.log(res)
          if (res.data.status == 'error') {
            this.$msg(res.data.msg)
          } else {
            let vipInfo = res.data.data
            vipInfo.userId = id
            let vipTypeMapping = {
              21: 'vip体验',
              22: 'vip季度',
              23: 'vip年度',
              31: 'svip体验',
              32: 'svip季度',
              33: 'svip年度',
            };
            let vipType = vipInfo.vip_level_id in vipTypeMapping ? vipTypeMapping[vipInfo.vip_level_id] : '';
            vipInfo.type = vipType
            this.userVipInfo = vipInfo
            this.centerDialogVisible = true
          }
        });
    },
    goToTaskPage(id) {
      // console.log(id)
      this.$router.push({
        path: '/userTaskPage',
        query: {
          user_id: id,
        }
      });
    },
    resetBtn() {
      this.key = this.user_name = this.user_id = ''
      localStorage.removeItem('phoneNumber');
      this.pages = 1;
      this.getUserList();
    },
    clickGrouping(id) {
      console.log(id, 'scope.row.idscope.row.idscope.row.id')
      this.$router.push({
        path: '/userGroupDetails',
        query: {
          user_id: id,
        }
      });
    },
    // 导出记录
    downloadRecord() {
      this.buttonLoading = true
      this.exportConfirm()
    },
    // 按钮确定
    exportConfirm() {
      let limit = 10000
      this.$getFile(`/v1/admin/users?pages=${this.pages}&limit=${limit}&key=${this.key}&time_name=${this.time_name}&start_time=${this.start_time}&end_time=${this.end_time}&user_name=${this.user_name}&user_id=${this.user_id}&export=${this.exportData}`, {})
        .then((res) => {
          console.log(res, 'ressss')
          if (res.status === 200) {
            this.downloadFile(res.data)
          } else {
            this.$msg(res.statusText)
          }
        });
    },
    downloadFile(file) {
      const date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');

      const gameStartTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      const blob = new Blob([file], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8' }) // 构造一个blob对象来处理数据，并设置文件类型
      if (window.navigator.msSaveOrOpenBlob) { //兼容IE10
        navigator.msSaveBlob(blob, this.filename)
      } else {
        const href = URL.createObjectURL(blob) //创建新的URL表示指定的blob对象
        const a = document.createElement('a') //创建a标签
        a.style.display = 'none'
        a.href = href // 指定下载链接
        // if (this.key != '') {
        //   a.download = `用户${this.key}数据.xls` //指定下载文件名
        // } else if (this.start_time != '' && this.end_time != '') {
        //   a.download = `${this.start_time}--${this.end_time}数据.xls` //指定下载文件名
        // } else if (this.time_name != '') {
        //   a.download = `${this.time_name}数据.xls` //指定下载文件名
        // } else if (this.user_name != '') {
        //   a.download = `用户-${this.user_name}数据.xls` //指定下载文件名
        // } else if (this.user_id != '') {
        //   a.download = `用户id为"${this.user_name}"数据.xls` //指定下载文件名
        // } else {
        //   a.download = `用户数据.xls` //指定下载文件名
        // }

        a.download = `用户数据${gameStartTime}.xls` //指定下载文件名
        a.click() //触发下载
        this.buttonLoading = false
        URL.revokeObjectURL(a.href) //释放URL对象
      }
    },
  },
  created() {
    if (localStorage.getItem('hasUserInput') === 'true') {
      const cachedPhone = localStorage.getItem('phoneNumber');
      if (cachedPhone) {
        this.key = cachedPhone;
      }
    }
    this.getUserList()
  },
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
  .user-list
    .el-table .warning-row {
      background: oldlace;
    }

    .el-table .success-row {
      background: #f0f9eb;
    }
    .search
      margin 20px 0
      display flex
      justify-content flex-start
      input
        width 220px
    .time-screen
      margin-bottom:20px;
      display flex
      align-items center
      >span
        margin-right: 10px;
      .time
        margin: 0 10px 0 40px;
    .list
      min-height 520px
      border 1px solid #EBEEF5
      .user_information
        color #00a0e9
        cursor pointer
    .block
      margin-top:10px;

</style>

<style scoped>
.flex_box {
  margin: 12px;
  text-align: right;
}

.flex_box div {
  margin: 10px;
}

.right_box div {
  margin: 10px;
}

.right_box {
  color: red;
}

.dialog_style {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 19px;
  color: #000;
}

.el-button--pink {
  color: #fff;
  background-color: #ff69b4;
  border-color: #ff69b4;
}

.el-button--pink:hover {
  background-color: #ff8db3;
  border-color: #ff8db3;
}
.btn_red{
  color: #fff;
  background-color: red;
  border-color: red;
}
.btn_orange{
  color: #000;
  background-color: orange;
  border-color: orange;
}
.btn_yellow{
  color: #000;
  background-color: rgb(234, 234, 0);
  border-color: rgb(234, 234, 0);
}
.btn_green{
  color: #fff;
  background-color: green;
  border-color: green;
}
.btn_cyan{
  color: #000;
  background-color: cyan;
  border-color: cyan;
}
.btn_blue{
  color: #fff;
  background-color: blue;
  border-color: blue;
}
.btn_purple{
  color: #fff;
  background-color: purple;
  border-color: purple;
}
</style>



// WEBPACK FOOTER //
// src/pages/UserManage/UserList.vue